<template>
    <Dialog
        :header-text="$t('Activate client portal')"
        :value="value"
        :width="520"
        @close_modal="$emit('close')"
    >
        <div class="body-2 jesus-take-the-wheel">
            {{ $t("After activation, you can send tasks directly to all client's contacts who have an e-mail address.") }}
        </div>
        <div class="title pb-5 pt-1">
            <checkbox
                :value="form_data.send_welcome_invitation"
                @change="form_data.send_welcome_invitation = $event"
            >
                <span class="title">{{ $t('Send welcome invitation to client contacts') }}</span>
            </checkbox>
        </div>
        <div v-if="form_data.send_welcome_invitation" class="jesus-take-the-wheel">
            <div class="title mb-1">
                {{ $t('Who will receive an invitation?') }}
            </div>
            <div class="mb-3">
                <ol>
                    <li>{{ $t("Client contact who has one valid e-mail address") }}</li>
                    <li>{{ $t("Client contact who has the client's portal open (default for all)") }}</li>
                </ol>
            </div>
            <div class="title mb-1">
                {{ $t('How does the invitation work?') }}
            </div>
            <div class="pb-3">
                <ol>
                    <li>{{ $t("Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.") }}</li>
                    <li>{{ $t("Uku client portal always informs clients by email about new tasks.") }}</li>
                </ol>
            </div>
        </div>
        <template slot="footer">
            <secondary-button
                @click.prevent="showClientPortalTemplates()"
            >
                {{ $t("View templates")}}
            </secondary-button>
            <v-spacer />
            <secondary-button @click="$emit('close')">
                {{ $t("Cancel" ) }}
            </secondary-button>
            <primary-button :loading="loading" @click="activate()">
                {{ $t("Activate") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import Vue from "vue";
import { ref } from "@vue/composition-api";
import ClientModule from '@/store/modules/client'
import AppModule from "@/store/modules/app";
import Dialog from "@/components/Dialog.vue";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import {$t} from "@/i18n";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "BulkEditClientPortalDialog",
    components: {
        Dialog
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        accountId: {
            type: Number,
            required: true
        },
        clientIdList: {
            type: Array,
            required: true
        }
    },
    setup(props, context) {
        const clientModule = ClientModule();
        const {
            handleErrorResponse,
            clearValidationErrors
        } = AppModule();
        const form_data = ref(null);
        const loading = false;

        const load_data = function () {
            form_data.value = Vue.prepare_form_data(
                {
                    action: "activate_client_portal",
                    company_id: props.accountId,
                    person_id: 0,
                    client_id_list: props.clientIdList,
                    send_welcome_invitation: true
                }
            );
        };

        const { showFeedbackNotification } = FeedbackNotificationModule();
        const activate = function () {
            let params = Vue.clean_and_clone_object(form_data.value);
            clearValidationErrors(form_data.value);
            clientModule
                .bulkClientsAction(params)
                .then(function (response) {
                    // this looks like a good candidate for refactoring
                    response.clients.forEach(respClient => {
                        let client = clientModule.getClient(respClient.id)
                        if(client) client.cp_is_active = respClient.cp_is_active
                    })
                    context.emit("close");
                    showFeedbackNotification($t('Client portal activated'))
                }).catch(ex => {
                    errorDialog.showError(ex)
                    context.emit("close")
                    context.emit("failed", ex.response.data.error_ids)
                })
        };

        load_data();

        const showClientPortalTemplates = () => {
            window.open(`/store/${props.accountId}/?open_app_name=client_portal&open_app_tab=templates`, '_blank')
        }

        return {
            form_data,
            loading,
            activate,
            showClientPortalTemplates
        };
    }
};
</script>
<style lang="scss" scoped>
.jesus-take-the-wheel {
    line-height: 1.125rem;
    .title {
        font-size: 1rem!important;
    }
    li {
        padding-bottom: 4px;
    }
}
</style>